import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { OverlayService } from '../../../../services/overlay.service';
import { SmartLocalStorageService } from '../../../../services/smart-local-storage.service';
import { ComponentService, CreatorFrontApi } from '../../../../services/component.service';
import { NewApiHttpService, NewApiResponse } from '../../../../services/new-api-http.service';
import { throwError } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { MaintenanceService } from '../../../../services/maintenance.service';

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {
	@ViewChild('editUserModal', { static: true }) editUserModal;

	start;
	maxPaginationItems = 10;
	currentPage;
	esp;
	name;
	direction = 'DESC';
	order = 'last_login';
	usersList = [];
	total;
	userToEdit;
	showEditModal = false;
	showDeleteModal = false;
	orderBy;

	constructor(
		private comService: ComponentService,
		private newApiHttpService: NewApiHttpService,
		private overlay: OverlayService,
		private route: ActivatedRoute,
		private router: Router,
		private localStorage: SmartLocalStorageService,
		private auth: AuthService,
		private maintenance: MaintenanceService
	) {}

	ngOnInit() {
		this.start = this.route.snapshot.params['start'] ? this.route.snapshot.params['start'] : 0;
		this.currentPage = +this.start + 1;
		this.esp = this.route.snapshot.params['esp'] ? this.route.snapshot.params['esp'] : 1;
		this.name = this.route.snapshot.params['name'] ? this.route.snapshot.params['name'] : '';
		this.direction = this.route.snapshot.params['type'] ? this.route.snapshot.params['type'] : this.direction;
		this.order = this.route.snapshot.params['order'] ? this.route.snapshot.params['order'] : this.order;
		this.orderBy =
			this.route.snapshot.params['order'] && this.route.snapshot.params['type']
				? `${this.route.snapshot.params['order']}${this.route.snapshot.params['type']}`
				: `${this.order}${this.direction}`;

		this.getUsers(this.start, this.esp, this.name, this.order, this.direction);
	}

	refreshUsers() {
		this.getUsers(this.start, this.esp, this.name, this.order, this.direction);
	}

	getUsers(start, esp, name, order, direction) {
		this.overlay.updateOverlay(true, 'Loading Users List...');
		const data = {
			start: start,
			esp: esp,
			name: name,
			count: '12',
			order: order,
			direction: direction
		};

		this.newApiHttpService.newApiRequestGet('user', data).subscribe(
			(response: NewApiResponse) => {
				if (!response || !response.status) {
					this.overlay.updateOverlay(true, response.message, 'alert');
				} else if (response.status) {
					this.total = response.data.count;
					this.usersList = response.data.rows;
				}
				this.overlay.updateOverlay(false);
			},
			(error) => {
				this.maintenance.serverMaintenance(error);
				console.log(`Creator Handling Error: ${JSON.stringify(error)}`);
				this.overlay.updateOverlay(false);
			}
		);
	}

	pageChanged(event: any): void {
		window.scrollTo(0, 0);
		this.start = !isNaN(parseFloat(event)) && isFinite(event) ? event : event.page - 1;
		this.currentPage = +this.start + 1;
		const urlParams = ['admin', 'users', this.start];
		if (this.orderBy) {
			this.direction = this.orderBy.includes('DESC') ? 'DESC' : 'ASC';
			this.order = this.orderBy.replace('DESC', '').replace('ASC', '');
		}
		if (this.esp || this.name || this.direction || this.order) {
			urlParams.push(this.esp);
			urlParams.push(this.name);
			urlParams.push(this.order);
			urlParams.push(this.direction);
		}
		this.router.navigate(urlParams).then(() => {
			this.getUsers(this.start, this.esp, this.name, this.order, this.direction);
		});
	}

	handleOutput(event) {
		switch (event.method) {
			case 'delete':
				this.deleteUser(event.userId);
				break;
			case 'unlock':
				this.unlockUser(event.userId);
				break;
			case 'workAs':
				this.workAsUser(event.user);
				break;
			case 'editUser':
				this.editUser(event.user);
				break;
			case 'deleteUserModal':
				this.deleteUserModal(event.user);
				break;
		}
	}

	deleteUser(userId) {
		if (confirm('Are you sure you want to DELETE this user ???')) {
			if (confirm('Are you sure you COMPLETELY SURE ???')) {
				const data = { userID: userId };
				this.newApiHttpService.newApiRequestDelete('user', data).subscribe((response: NewApiResponse) => {
					this.pageChanged(this.start);
				});
			}
		}
	}

	deleteUserModal(user) {
		this.userToEdit = user;
		this.showDeleteModal = true;
	}

	unlockUser(userId) {
		if (confirm('Are you sure you want to Unlock this user ???')) {
			const data = { userID: userId };
			this.comService.apiRequest('unlockUser', data).subscribe((response: CreatorFrontApi) => {
				this.pageChanged(this.start);
			});
		}
	}

	workAsUser(user) {
		if (confirm('Are you sure you want to work as ' + user.name + ' ???')) {
			const data = { email: user.email.trim() };

			this.newApiHttpService.newApiRequestPost('user/working-as', data).subscribe(
				(response: any) => {
					if (response && response.status && response.token) {
						const workAsUser = jwt_decode(response.token);
						workAsUser['workingAs'] = true;
						const previousUser = this.auth.getUser();
						if (typeof previousUser['originalUser'] !== 'undefined' && previousUser['originalUser']) {
							workAsUser['originalUser'] = previousUser['originalUser'];
						} else {
							workAsUser['originalUser'] = previousUser;
						}
						workAsUser['jwt'] = response.token;
						const userSig = btoa(JSON.stringify(workAsUser));
						this.localStorage.setLocalStorage('c-user', userSig);
						this.router.navigate(['']);
					} else {
						return throwError('Failed to work as ' + user.name + 'Please try again');
					}
				},
				(error) => {
					console.log(`Creator Handling Error: ${JSON.stringify(error)}`);
				}
			);
		}
	}

	addNewUser() {
		this.userToEdit = null;
		this.showEditModal = true;
	}

	editUser(user) {
		this.userToEdit = user;
		this.showEditModal = true;
	}
}
